import React, {useCallback, useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom"; // useNavigate import karein
import {styled, useTheme} from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import {useDispatch, useSelector} from "react-redux";
import {setAppBarHeight} from "../../Modules/Common/App";
import {AccountMenu} from "../Menu/AccountMenu";
import {NotificationMenu} from "../Menu/NotificationMenu";
import {Container, Stack, Tab, Tabs} from "@mui/material";

const StyledTabs = styled(Tabs)(({ theme }) => ({
    marginBottom: '-8px',
    marginLeft: theme.spacing(5),
    '& .MuiTabs-indicator': {
        height: 1,
        backgroundColor: theme.palette.primary.dark,
    },
    '& .MuiTab-root': {
        color: theme.palette.text.primary,
        textTransform: 'capitalize',
        fontSize: '1.1rem',
        '&.Mui-selected': {
            color: theme.palette.primary.main,
        },
    },
}));

export const AppBarPublic = () => {

    const theme = useTheme();
    const dispatch = useDispatch();
    const config = useSelector((store) => store.app);
    const open = config.leftDrawer.open;
    const drawerWidth = config.leftDrawer.width;
    const [, setCurrentMetrics] = useState();

    // useNavigate hook ko initialize karein
    const navigate = useNavigate();

    // Tabs ke liye state banayein
    const [tabValue, setTabValue] = useState(0);

    const StyledAppBar = styled(MuiAppBar, {
        shouldForwardProp: (prop) => prop !== 'open',
    })(({ theme, open }) => ({
        background: theme.appBarPublic?.backgroundColor || '#ffffff',
        zIndex: theme.zIndex?.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        }),
    }));

    const appBarRef = useRef(null)

    useEffect(()=>{
        dispatch(setAppBarHeight(appBarRef.current.clientHeight));
    },[dispatch])

    const metrics = useCallback(() => {
        const width = window.innerWidth;
        if (width < theme.breakpoints.values.sm) {
            return 'xs';
        } else if (width < theme.breakpoints.values.md) {
            return 'sm';
        } else if (width < theme.breakpoints.values.lg) {
            return 'md';
        } else if (width < theme.breakpoints.values.xl) {
            return 'lg';
        } else {
            return 'xl';
        }
    }, [theme.breakpoints.values]);

    useEffect(() => {
        const handleResize = () => {
            setCurrentMetrics(metrics());
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [metrics]);

    // Tab change handler function
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        switch (newValue) {
            case 0:
                navigate('/halls');
                break;
            case 1:
                navigate('/meeting-rooms');
                break;
            case 2:
                navigate('/conference-rooms');
                break;
            default:
                break;
        }
    };

    return (
        <StyledAppBar position="fixed" open={open} ref={appBarRef}>
            <Container
                sx={{
                    maxWidth: {
                        xs: "100vw",
                        sm: "90vw",
                        md: "92vw",
                        lg: "95vw",
                        xl: "55vw",
                    },
                    minWidth: {
                        xs: "320px",
                        sm: "540px",
                        md: "720px",
                        lg: "960px",
                        xl: "1320px",
                    },
                    p: 1,
                }}
            >
                <Toolbar disableGutters>
                    <Box>
                        <Box
                            component="img"
                            src="/images/logo-dark.svg"
                            alt={'ADNEC Bookings'}
                            sx={{ height: 64 }}
                        />
                    </Box>

                    <Box sx={{ flexGrow: 1 }} />

                    {/* StyledTabs me value aur onChange prop add karein */}
                    <StyledTabs
                        sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }}
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label={"Halls"} value={0} />
                        <Tab label={"Meeting Rooms"} value={1} />
                        <Tab label={"Conference Rooms"} value={2} />
                    </StyledTabs>

                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ display: { md: 'flex' } }}>
                        <Stack direction={"row"} spacing={1}>
                            <NotificationMenu />
                            <AccountMenu />
                        </Stack>
                    </Box>
                </Toolbar>
            </Container>
        </StyledAppBar>
    )
}